// extracted by mini-css-extract-plugin
export default {"title":"SingleMessagePageWrapper_title__5rwK2"};